import { getNamespace } from 'communicator/store/selectors';

const namespace = getNamespace();

export default {
  addPaymentInstrument: '/wallet-services-web/pi/account/ARMGUID/paymentinstrument',
  authenticate: '/wallet-services-web/authentications/authenticate',
  cardMetadataSvc: {
    cardBins: '/cardMetadataSvc/cardBins'
  },
  createAccount: '/consumer-api/v2/account/ARMGUID',
  device: '/consumer-api/v1/device',
  enrollCard: '/wallet-services-web/src/v1/cards',
  enrollCardXo: '/wallet-services-web/src-xo/v1/cards',
  enrollSsi: '/consumer-api/v1/account/ARMGUID/ssi/enrollStaySignedIn',
  eventLogging: '/logging/logEvent',
  intent: '/wallet-services-web/xo/account/ARMGUID/intent',
  orchestrator: {
    checkout: '/apn/src-orchestrator-web/src/api/management/transaction/credentials',
    checkoutEnroll: '/apn/src-orchestrator-web/src/api/management/checkout/enroll',
    checkoutPrepare: '/apn/src-orchestrator-web/srci/api/management/checkout/prepare',
    enrollCardCoF: '/apn/src-orchestrator-web/src/api/management/cards',
    enrollSsi: '/apn/src-orchestrator-web/src/api/management/identity/ssi/enroll',
    idLookup: '/apn/src-orchestrator-web/src/api/management/identity/idLookup',
    prepare: '/apn/src-orchestrator-web/src/api/management/profiles/prepare',
    probe: `/apn/src-orchestrator-web/src/api/management/identity/validation/complete`,
    recognize: '/apn/src-orchestrator-web/src/api/management/identity/recognize',
    reissuance: '/apn/src-orchestrator-web/src/api/management/identity/validation/initiate'
  },
  purchaseIntent: '/wallet-services-web/xo/intent',
  token: {
    auth: `/apn/${namespace}/oauth2/token`,
    idLookup: `/apn/${namespace}/oauth2/token/idproof/promise/idLookup`,
    probe: `/apn/${namespace}/oauth2/token/probe`,
    reissuance: `/apn/${namespace}/oauth2/token/probe/reissuance`,
    renewal: `/apn/${namespace}/oauth2/token/renewal`,
    revoke: `/apn/${namespace}/oauth2/lcm/token/authorized/revocation`,
    spawn: `/apn/${namespace}/oauth2/token/spawn`,
    tnc: `/apn/${namespace}/oauth2/token/tnc`
  },
  userDetail: '/consumer-controller/v1/account/ARMGUID'
};
